import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';
import { StatusLoading } from 'common/constants/statusLoading';

const action = (
  state: IState,
  payloadAction: PayloadAction<{ id: number; statusLoading: StatusLoading }>,
) => {
  const { id, statusLoading } = payloadAction.payload;

  state.savedFilters.data = {
    ...state.savedFilters.data,
    [id]: {
      ...state.savedFilters.data[id],
      statusLoading,
    },
  };
};

export default action;
